import { IconHeart } from "./svg-icons/IconHeart.tsx";
import '../styles/components/WishlistLink.css';
import { useWishlist } from '../contexts/WishlistContext';
import { useState } from 'preact/hooks';

interface WishlistLinkProps {
    postId: string,
    activeClass?: string
    showTitle?: boolean
    alternativeTitle?: string
}

export function WishlistLink({
    postId,
    activeClass = '',
    showTitle = false,
    alternativeTitle
}: WishlistLinkProps) {

    const { isInWishlist, toggleWishlist } = useWishlist();
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState<string>('');
    const [animationClass, setAnimationClass] = useState<string>('');

    const isActive = isInWishlist(postId);
    const combinedActiveClass = isActive ? `${activeClass} active` : activeClass;
    const fullClassName = `wishlist ${combinedActiveClass} ${animationClass} ${isLoading ? 'loading' : ''}`;

    const handleClick = async (e: Event) => {
        e.preventDefault();

        if (isLoading) return;

        const wasInWishlist = isInWishlist(postId);

        // Set waiting animation while processing
        setAnimationClass('waiting');
        setIsLoading(true);
        setMessage('');

        try {
            const response = await toggleWishlist(postId);

            if (response.success) {
                // Remove waiting animation and add success animation
                setAnimationClass('');

                // Add jump animation for successful add
                if (!wasInWishlist && response.type === 'success-add') {
                    setTimeout(() => {
                        setAnimationClass('jump');
                        setTimeout(() => setAnimationClass(''), 900); // Duration of jump animation
                    }, 50);
                }

                setMessage(response.message);
                // Clear message after 3 seconds
                setTimeout(() => setMessage(''), 3000);
            } else {
                setAnimationClass('');
                setMessage(response.message || 'Ein Fehler ist aufgetreten');
                setTimeout(() => setMessage(''), 3000);
            }
        } catch (error) {
            console.error('Wishlist error:', error);
            setAnimationClass('');
            setMessage('Ein Fehler ist aufgetreten');
            setTimeout(() => setMessage(''), 3000);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            {postId && (
                <div className="wishlist-container">
                    <a
                        href="#"
                        className={fullClassName}
                        data-pid={postId}
                        onClick={handleClick}
                        rel="nofollow noopener noreferrer"
                    >
                        <span className="icon">
                            <IconHeart />
                        </span>
                        {showTitle && !alternativeTitle && (<span className="text">Merkliste</span>)}
                        {showTitle && alternativeTitle && (<span className="text">{alternativeTitle}</span>)}
                        {isLoading && (<span className="text loading-text">...</span>)}
                    </a>
                    {/* disabled on purpose */}
                    {false && message && (
                        <div className="wishlist-message">
                            {message}
                        </div>
                    )}
                </div>
            )}
        </>
    )
}
